import React from 'react';
import { CalendarCheckIcon, ClipboardListIcon, FileCheckIcon, PuzzleIcon, SigmaIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  list: ClipboardListIcon,
  check: FileCheckIcon,
  calendar: CalendarCheckIcon,
  sigma: SigmaIcon,
  puzzle: PuzzleIcon
};

/* Colores de cada bono, igual que en la portada del pack */
const BONUS_COLORS = ['bg-pink-600', 'bg-emerald-600', 'bg-orange-600', 'bg-brand-blue', 'bg-violet-600'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-brand-gray text-brand-navy" data-id="element-27" data-mp="1ej4awflln3ro">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="1el8d8t3unupu">
        <h2 id="bonos" className="font-display text-lg font-black uppercase leading-tight sm:text-2xl" data-id="element-29" data-mp="19kt0a2nhcp8e">
          <span className="bg-brand-yellow px-1.5" data-id="element-30" data-mp="1jigwyy4nc6t7">5 Bonos incluidos</span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-slate-700" data-id="element-31" data-mp="1jgdzxu52tdez">
          Y además recibes 5 recursos prácticos — GRATIS con tu compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-32" data-mp="3tsfdyqx2xdz2">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-lg border-2 border-brand-navy/10 bg-white text-left" data-id="element-33" data-mp="7l8k5fvfo0vf" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 font-display text-[0.62rem] font-black uppercase tracking-[0.1em] text-white ${BONUS_COLORS[i]}`} data-id="element-34" data-mp="gjapg7m79foi">
                  <Icon size={12} aria-hidden="true" data-id="element-35" data-mp="qd1at3n159zz" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-36" data-mp="109e5a3qefrvs">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-37" data-mp="109mgzsascr5e">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-slate-700" data-id="element-38" data-mp="5mxd6nqkzmw3">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1 font-display text-sm font-extrabold uppercase tracking-wide text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-39" data-mp="kclhzyxz13ok">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-lg border-2 border-dashed border-brand-orange bg-white px-3 py-2 font-display text-[0.78rem] font-black uppercase leading-tight sm:text-sm" data-id="element-40" data-mp="ocds4g30jhw1">
          <p data-id="element-41" data-mp="ybcp31ef1p37">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-red-600" data-id="element-42" data-mp="350rca95zjs9o">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}